import { render, staticRenderFns } from "./BookingTransferList.vue?vue&type=template&id=b891d1c2&scoped=true"
import script from "./BookingTransferList.vue?vue&type=script&lang=js"
export * from "./BookingTransferList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b891d1c2",
  null
  
)

export default component.exports